<template>
  <table :data-time="time" class="pco-painel-form">
    <tbody>
      <tr v-for="(historico, indexH) in listaPCO" :key="'his-' + indexH" :style="([ '', null, undefined ].indexOf(historico.id_pco_item_id_pco_status_item_cor_fundo) === -1 ? (' background: ' + historico.id_pco_item_id_pco_status_item_cor_fundo + ';') : '') + ([ '', null, undefined ].indexOf(historico.id_pco_item_id_pco_status_item_cor_letra) === -1 ? (' color: ' + historico.id_pco_item_id_pco_status_item_cor_letra + ';') : '')">
        <td class="obs" style="min-width: 130px; max-width: 250px;">
          <div>
            <!-- ADICIONA A ALTERAÇÃO -->
            <div v-html="'Alterado por ' + historico.last_user_usuario + ' em ' + historico.data_hora_ptbr + ': '"></div>

            <!-- ADICIONA A OBSERVAÇÃO -->
            <div v-html="historico.id_pco_item_id_pco_status_item_nome"></div>
          </div>
        </td>

        <td class="obs">
          <template v-if="historico.obs.length >= 1">
            <div v-for="(obs, indexO) in historico.obs" :key="'his-' + indexH + '-obs-' + indexO">
              <!-- ADICIONA A ALTERAÇÃO -->
              <div v-html="'Inserido por ' + obs.last_user_usuario + ' em ' + obs.last_at_ptbr + ': '"></div>

              <!-- ADICIONA A OBSERVAÇÃO -->
              <div v-html="obs.observacao"></div>
            </div>
          </template>
          <div v-else style="text-align: center;">---</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
  .pco-painel-form {
    width: 100%;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    margin: 0px 0px;
    border-collapse: separate;
    border-spacing: 0px 5px;
    text-shadow: none;
  }
    .pco-painel-form > tbody > tr > td:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .pco-painel-form > tbody > tr > td:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .pco-painel-form > tbody > tr > td {
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
      .pco-painel-form > tbody > tr > td:first-child {
        border-left: 1px solid #ccc;
      }
      .pco-painel-form > tbody > tr > td {
        border-right: 1px solid #ccc;
        padding: 5px;
      }

  .nome {
    min-width: 165px;
    text-align: left;
  }
  .obs {
    text-align: left;
    vertical-align: top;
  }
    .obs > div:not(:first-child) {
      margin-top: 7px;
    }
    .obs > div > div:first-child {
      font-size: var(--font-base-soma-09);
    }
    .obs > div > div:last-child {
      padding-top: 2px;
      padding-left: 5px;
    }
    .obs > button {
      width: 20px;
      height: 20px;
      padding: 0px;
      margin: 0px;
      text-align: center;
      vertical-align: middle;
      margin-right: -5px;
      margin-top: -7px;
    }
  .usuario {
    width: 120px;
    text-align: center;
  }
  .data {
    width: 120px;
    text-align: center;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntRefMod: {
        required: true
      },
      cpntRefId: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        listaPCO: []
      }
    },
    mounted: function () {
      this.pcoHistoricoIniciar()
    },
    methods: {
      pcoHistoricoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.pcoHistoricoSetarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA INICIAR O PROCESSO
        this.pcoHistoricoBuscarObsProcesso()
      },
      pcoHistoricoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoHistoricoBuscarObsProcesso: function (callback = null) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, order: { data_hora: 'desc' } }

        // SETA OS CAMPO QUE DEVEM SER RETORNADO
        queryGet.field = {
          id: null,
          id_pco_item: { j: { id_pco_status_item: { j: { nome: null, cor: { a: 'id_pco_item_id_pco_status_item_cor_fundo' } } } } },
          last_user: { j: { usuario: null } },
          data_hora: null
        }

        // SETA O WHERE DA PESQUISA
        queryGet.where = { aAnd: [ { m: 'pco_item_tempo', f: 'status', o: '=', v: '1' } ] }

        // VERIFICA O WHERE QUE DEVE REALIZAR
        switch (this.cpntRefMod) {
          case 12:
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'id_ven_pro', o: 'in', v: this.cpntRefId.join() })
            break

          case 10:
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'cod_venda', o: 'in', v: this.cpntRefId.join() })
            break
        }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/con-processo/tempo/get/', 'GET', queryGet, (apiSuccess) => {          
          // SETA OS DADOS RECEBIDOS DA API
          this.listaPCO = apiSuccess.data

          // INICIA OS VETOR DE IDS
          var ids = []

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

          // ADICIONA TODOS OS IDS RECEBIDOS NO VETOR
          for (var indexL in this.listaPCO) {
            // SETA O ID DO CAMPO
            ids.push(this.listaPCO[indexL].id)

            // CALCULA A COR DA LETRA
            this.listaPCO[indexL].id_pco_item_id_pco_status_item_cor_letra = FUN_VERIFICA_COR_LETRA(this.listaPCO[indexL].id_pco_item_id_pco_status_item_cor_fundo)

            // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
            this.listaPCO[indexL].obs = []
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA CARREGAR AS OBSERVAÇÕES DE CADA LINHA
          this.pcoHistoricoCarregarObservacoesPCO(ids, callback)
        }, this.pcoHistoricoSetarStatusGeral)
      },
      pcoHistoricoCarregarObservacoesPCO: function (ids, callback, qtde = 350, ini = null, fim = null) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // MONTA A PESQUINA NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, order: { last_at: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            id_pco_item_tempo: null,
            observacao: null,
            last_user: { j: { usuario: null } },
            last_at: null
          }

          // SETA O WHERE DO CADASTRO
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pco_item_tempo', o: 'in', v: ids.slice(ini, fim).join() } ] }

          // REALIZA A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/con-processo/observacao/get/', 'GET', queryGet, (apiSuccess) => {
            // ADICIONA OS VALORES RECEBIDOS NAS LINHAS
            for (var indexV in apiSuccess.data) {
              // PEGA O NUMERO DA LINHA
              var indexL = this.listaPCO.findIndex(item => item.id === apiSuccess.data[indexV].id_pco_item_tempo)

              // ADICIONA OS VALORES RECEBIDOS A LINHA
              this.listaPCO[indexL].obs.push(apiSuccess.data[indexV])
            }

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            this.pcoHistoricoCarregarObservacoesPCO(ids, callback, qtde, ini, fim)
          }, this.pcoHistoricoSetarStatusGeral)
        } else {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
    },
    watch: {
      cpntRefMod: function () {
        this.pcoHistoricoIniciar()
      },
      cpntRefId: function () {
        this.pcoHistoricoIniciar()
      }
    }
  }
</script>
